import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/ar";
// English needs no import — it's moment's built-in default locale.

// Moment's locale is a global mutable singleton, so it must be synced from a
// single place. Several components used to call `moment.locale("fr")` on
// their own at module scope, which meant whichever one last mounted "won"
// and silently overrode every other component's date formatting — mount
// this once near the app root instead.
export const useSyncMomentLocale = () => {
    const {i18n} = useTranslation();

    useEffect(() => {
        moment.locale(i18n.language);
    }, [i18n.language]);
};
